import logo from './logo.svg';
import React from 'react';
import ReactDOM from "react-dom";
import {BrowserRouter, Routes, Route, Outlet, useParams} from "react-router-dom";
import './App.css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';

import axios from "axios";
import { Navigate } from 'react-router-dom';
import {createTheme, ThemeProvider} from '@mui/material/styles';

import MainHires from "./components/MainHiresDG";
import MainConfig from "./components/MainConfig";
import MainClients from "./components/MainClientsDG";
import MainSchedule from "./components/MainSchedule";
import Reminder from "./components/Reminder";
import ClientShow from "./components/ClientShow";
import MainLogs from "./components/MainLogs";
import MainCalc from "./components/MainCalc";
import Login from './components/Login'
import useToken from './components/useToken'

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#363537',
            dark: '#2d3b4c',
        },
        secondary: {
            main: '#b76615',
        },
        warning: {
            main: '#943215',
        },
        error: {
            main: '#ff3b80',
        },
        background: {
            default: '#a9a9a9',
            paper: '#424242',
        },
        finished: {
            main: '#ffffff',
            contrastText: '#353535',
        },
        current: {
            main: '#00a930',
        },
        overdue: {
            main: '#a9002e',
        },
        ending: {
            main: '#97a951',
        },
        confirmed: {
            main: '#a800a9',
        },
        waiting: {
            main: '#0030a9',
        },
        extend_request: {
            main: '#47a900',
            dark: '#4c0008',
        },
        close_request: {
            main: '#a90049',
            dark: '#4c0008',
        },
        extend_confirmation: {
            main: '#87a971',
            dark: '#4c0008',
        },
        close_confirmation: {
            main: '#a9747a',
            dark: '#4c0008',
        },
        reminder: {
            main: '#08a9a7',
            dark: '#2d3b4c',
        },
        paid: {
            main: '#08a9a7',
            dark: '#2d3b4c',
        },
        active: {
            main: '#08a9a7',
            dark: '#2d3b4c',
        }
    },
    typography: {
        fontFamily: 'Montserrat',
        fontWeightBold: 1000,
        fontWeightMedium: 600,
        fontSize: 11,
    },

});
export default function App() {
    const {token, removeToken, setToken} = useToken();
    const go = (event, c) => {
        event.preventDefault();
        //window.location.assign('/'+window.location.pathname.split('/')[1]);
        window.location.assign('/manage/hires');
    };

    function logMeOut() {
        removeToken()
        axios({
            method: "POST",
            url: "http://localhost:8000/logout",
        })
            .then((response) => {
            }).catch((error) => {
            if (error.response) {
                console.log(error.response)
                console.log(error.response.status)
                console.log(error.response.headers)
            }
        })
    }

    const Layout = () => {
        return (
            <Box>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" component="div">
                            ATD Hire Manager
                        </Typography>
                        <Button color="inherit" onClick={go}>HOME</Button>
                        <button onClick={logMeOut}>
                            Logout
                        </button>
                    </Toolbar>
                </AppBar>
                <Outlet/>
            </Box>
        )
    }
    const get_role = (role) => {
        switch (role) {
            case'driver':
                break;
            default:
        }
    }

    const ElLogin = <Login setToken={setToken}/>


    return (
        <ThemeProvider theme={theme}>
            <Container
                className="App App-header"
                maxWidth={false}
                sx={{
                    minHeight: "100vh",
                    backgroundColor: "background.default",
                }}
            >
                <Box sx={{display: "flex", flexDirection: "column", flexGrow: 1}}>
                    <BrowserRouter basename={process.env.PUBLIC_URL}>

                        {!token && token !== "" && token !== undefined ?
                            <Routes>
                                <Route path="/client" element={<Reminder/>}>
                                    <Route path=":userID" element={<ClientShow/>}/>
                                </Route>
                                <Route path="*" element={ElLogin}/>
                            </Routes>
                            : (
                                <Routes>
                                    <Route path="/" element={<Navigate to="/manage/hires"/>}/>

                                    <Route path="/manage" element={<Layout/>}>
                                        <Route path="hires" element={<MainHires/>}/>
                                        <Route path="clients" element={<MainClients/>}/>
                                        <Route path="schedule" element={<MainSchedule/>}/>
                                        <Route path="logs" element={<MainLogs/>}/>
                                        <Route path="calc" element={<MainCalc/>}/>
                                        <Route path="setup" element={<MainConfig/>}/>
                                    </Route>
                                    <Route path="/client" element={<Reminder/>}>
                                        <Route path=":userID" element={<ClientShow/>}/>
                                    </Route>
                                </Routes>)}
                    </BrowserRouter>
                </Box>
            </Container>
        </ThemeProvider>
    );
}
